import React, {useEffect} from "react"
import "../main.scss"
import PrissoknadList from "../components/PrissoknadList"
import {AlertResoker} from "../components/Alert/AlertResoker";
import {getDocumentTitle} from "../utils/documentTitle";

function Barnehagepris() {
    useEffect(() => {
        document.title = getDocumentTitle('pris-søknader')
    })

    return (
        <div className="pkt-cell pkt-cell--span12">
            <div className="px-size-8 px-size-16--phablet-up">
                <div className="mx-size-8 mx-size-8--tablet-up my-size-24 my-size-64--tablet-up">
                    <h1 className="pkt-txt-36 pkt-txt-40--tablet-up">
                        Søknad om redusert barnehagepris
                    </h1>
                </div>
                <AlertResoker className={'mb-size-32'}/>
                <PrissoknadList/>
            </div>
        </div>
    )
}

export default Barnehagepris
